import defaultTheme from 'tailwindcss/defaultTheme'

/** @type {import('tailwindcss').Config} */
export default {
	content: ['./vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php', './storage/framework/views/*.php', './resources/**/*.blade.php', './resources/**/*.vue', './resources/**/*.js'],
	theme: {
		container: {
			center: true,
			padding: '1rem',
		},
		extend: {
			fontSize: {
				'10xl': [
					'10rem',
					{
						lineHeight: 0.8,
					},
				],
				'4.5xl': [
					'2.75rem',
					{
						lineHeight: 1,
					},
				],
			},
			screens: {
				xs: '480px',
				'3xl': '1792px',
			},
			fontFamily: {
				'neue-haas-grotesk': ['neue-haas-grotesk-display', 'sans-serif'],
				'alternate-gothic': ['alternate-gothic-extra-cond', 'sans-serif'],
				cabazon: ['cabazon', 'sans-serif'],
			},
			colors: {
				crowns: {
					'off-black': '#080808',
					'dark-grey': '#111111',
					grey: '#1b1b1b',
					'castle-shadow': '#474747',
					'castle-stone': '#656565',
					clouds: '#b0b0b0',
					'off-white': '#d8d8d8',
				},
			},
			aspectRatio: {
				'9/5': '9 / 5',
				'4/3': '4 / 3',
				'12/5': '12 / 5',
				'16/18': '16 / 18',
				'18/16': '18 / 16',
			},
			height: {
				5.5: '1.375rem',
			},
			width: {
				5.5: '1.375rem',
			},
			animation: {
				'spin-very-slow': 'spin 10s linear infinite',
				'marquee-left-slow': 'marqueeLeft 135s linear infinite',
				'marquee-right-slow': 'marqueeRight 135s linear infinite',
			},
			scale: {
				102: '1.02',
			},
			brightness: {
				40: '.4',
			},
			backgroundImage: {
				'waves-pattern': "url('https://cdn.papercrowns.com/website/images/backgrounds/waves-pattern.png')",
				'modal-pattern': "url('https://cdn.papercrowns.com/website/images/backgrounds/modal-texture.png')",
			},
			backgroundSize: {
				'size-50': '50% auto',
				'size-60': '60% auto',
				'size-70': '70% auto',
				'size-80': '80% auto',
				'size-90': '90% auto',
			},
		},
	},
	plugins: [],
}
